import SearchCondition from './SearchCondition';

export default (props) => {
  return <SearchCondition {...props} />;
};
